import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../../../store/store';
import {
  FinancialDataManagerCreateActions,
  UiActions
} from '../../../store/actions';
import { DataNotClientService } from '../../../services/data-not-client.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RequestFinancialDataManagerCreate } from 'src/app/shared/interfaces';
import { RedirectService } from 'src/app/services/redirect.service';
import { ApiResponseStatus, StepsClientTypes, StepsNotClientTypes } from '../../../shared/enums';
import { PepComponent } from 'omnichannel2-commercial-platform-pep';
import { environment } from 'src/environments/environment';
import { DatadogService } from 'src/app/services/datadog/datadog.service';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { DataClientService } from 'src/app/services/data-client.service';
@Component({
  selector: 'lib-pep-form-joint',
  templateUrl: './pep-form-joint.component.html',
  styleUrls: ['../../../global.scss', './pep-form-joint.component.scss']
})
export class PepFormJointComponent implements OnInit, OnDestroy {
  private isWC = environment.isWc;
  expandedIndex: number | undefined;
  maskPep = false;
  pepCont = 0;
  isExecutive: boolean;
  isMarkByCIGO: boolean;
  pepMarkByCigo: boolean;
  showFisherman: boolean;
  varIsPepActive: boolean;
  isJointAccount: boolean;
  formData: FormGroup;
  privateMode: boolean;
  dataService: DataNotClientService | DataClientService;
  staticAssetsUrl = environment.staticScripts.staticAssets;

  @ViewChild(PepComponent, { static: false }) pep: PepComponent;
  invalidPep = false; // el invalidPep siempre se inicia con false, significa que el formulario es valido si nunca se modifica su estado
  SwitchData = [
    {
      title: '<strong>Eres una Persona Expuesta Pública y/o Políticamente (PEP)?</strong>',
      name: 'isPEPJoint',
      description: 'Personas expuestas políticamente (PEP) son personas naturales, nacionales o extranjeras, '
      + 'que cumplen o que en los últimos cinco (5) años hayan cumplido funciones públicas destacadas o funciones '
      + 'prominentes en una organización internacional, sea en territorio nacional o extranjero, y cuyas circunstancias '
      + 'financieras puedan ser objeto de un interés. Asimismo, se considera como PEP al colaborador directo de la máxima autoridad de la institución.'
    },
    {
      title: '<strong>¿Eres una persona que aplica a FATCA?</strong>',
      name: 'isFATCAJoint',
      description: 'FATCA (Foreign Account Tax Compilance Act) es una normativa que tiene como objetivo promover '
      + 'la transparencia fiscal y el cumplimiento de las obligaciones fiscales de los ciudadanos y residentes estadounidenses.'
    },
    {
      title: '<strong>¿Eres una persona que aplica a ECR?</strong>',
      name: 'isECRJoint',
      description: 'Estandar Común de Reporte o Common Reporting Standard (ECR), establece la calidad de información financiera '
      + 'que se intercambiará, las instituciones financieras sujetas a reportar dicha información, los distintos tipos de cuentas, los contribuyentes '
      + 'reportables, así como los procedimientos de debida diligencia que las instituciones financieras deben seguir. Aplica para extranjeros no estadounidenses.'
    }
  ];

  financialDataRequestManager$ = this.store.select(OnboardingProductsStore.selectors.financialDataManagerCreate);

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    private dataClientService: DataClientService,
    private dataDogService: DatadogService,
    public loadingService: LoadingService,
    public sessionService: SessionService,
    private _fb: FormBuilder,
    private redirectService: RedirectService
  ) {
    this.formData = this._fb.group({
      isPEPJoint: [false],
      isFATCAJoint: [false],
      isECRJoint: [false],
      isFishermanJoint: [false]
    });
  }

  financialDataRequestManagerSuscription = this.financialDataRequestManager$.subscribe(({ response, error }) => {
    if (error != null) {
      const step = this.privateMode ? StepsClientTypes.STEP_SERVICE_ERROR : StepsNotClientTypes.STEP_SERVICE_ERROR;
      const redirect = this.privateMode ? StepsClientTypes.STEP_PRIVATE_LANDING_JOINT : StepsNotClientTypes.STEP_PUBLIC_LANDING;
      this.redirectService.setRedirect(redirect);
      this.store.dispatch(FinancialDataManagerCreateActions.cleanState());
      this.store.dispatch(UiActions.Navigate({ step }));
      this.loadingService.loading = false;
    }

    if (response) {
      this.store.dispatch(FinancialDataManagerCreateActions.cleanState());
      if (response.client.operationState.code === ApiResponseStatus.OK &&
        response.joint.operationState.code === ApiResponseStatus.OK) {
        const redirect = this.privateMode ? StepsClientTypes.STEP_CURRENCY_TYPE : StepsNotClientTypes.STEP_CURRENCY_TYPE;
        if (this.formData.controls.isPEPJoint.value || this.formData.controls.isECRJoint.value || this.formData.controls.isFATCAJoint.value) {
          if (environment.mode === 'WEB-PF' || environment.mode === 'PF') {
            this.store.dispatch(UiActions.ToggleModal({
              text: 'No te olvides de imprimir el Formulario PEP, FATCA o ECR y completarlo con los datos del cliente.',
              buttonText: 'Continuar',
              icon: 'print',
              open: true,
              redirect
            }));
          }
        } else {
          this.store.dispatch(UiActions.Navigate({ step: redirect }));
        }
      } else {
        const redirect = this.privateMode ? StepsClientTypes.STEP_SERVICE_ERROR : StepsNotClientTypes.STEP_SERVICE_ERROR;
        this.store.dispatch(UiActions.Navigate({ step: redirect }));
      }
    }
  });

  ngOnInit() {
    this.setService();
    this.store.select('stepsNoClient').subscribe();
    this.checkFisherman();
    this.checkNationality();
    this.checkCigoData();
  }

  ngOnDestroy() {
    this.financialDataRequestManagerSuscription.unsubscribe();
  }

  setService() {
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.isExecutive = environment.mode === 'WEB-PF' || environment.mode === 'PF' ? true : false;
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    const googleAnalytics = {
      is_joint_account: this.dataService.isIsJointAccount(),
      job_information: {
        workActivityType: this.dataService.getWorkActivityTypeJoint() ? this.dataService.getWorkActivityTypeJoint() : 'No informado',
        dateEntryWork: this.dataService.getDateEntryWorkJoint() ? this.dataService.getDateEntryWorkJoint() : 'No informado',
        companyName: this.dataService.getCompanyNameJoint() ? this.dataService.getCompanyNameJoint() : 'No informado',
        rucCompany: this.dataService.getRucCompanyJoint() ? this.dataService.getRucCompanyJoint() : 'No informado',
        profession: this.dataService.getProfessionJoint() ? this.dataService.getProfessionJoint() : 'No informado'
      }
    };
    this.store.dispatch(TagPage({ text: 'pep-fatca-ecr-information-joint', extras: googleAnalytics }));
  }

  continue() {
    this.dataService.setIsPEPJoint(this.formData.controls.isPEPJoint.value);
    this.dataService.setIsECRJoint(this.formData.controls.isECRJoint.value);
    this.dataService.setIsFATCAJoint(this.formData.controls.isFATCAJoint.value);
    this.dataService.setIsFishermanJoint(this.formData.controls.isFishermanJoint.value);

    const channel = this.privateMode ? 'client' : 'not client';
    this.dataDogService.addCustomEvent('Personal information joint completed', environment.mode, { channel });

    this.privateMode ? this.continueInClientMode() : this.financialDataDispatch();
  }

  continueInClientMode() {
    if (environment.mode === 'PF' || environment.mode === 'WEB-PF') {
      this.financialDataDispatch();
    } else {
      this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SUCURSAL_DERIVATION }));
    }
  }

  financialDataDispatch() {
    this.loadingService.loading = true;
    const request: RequestFinancialDataManagerCreate = {
      client: {
        pep: this.dataService.getIsPEP(),
        ecr: this.dataService.getIsECR(),
        fatca: this.dataService.getIsFATCA(),
        trabajadorPesquero: this.dataService.getIsFisherman()
      },
      joint: {
        pep: this.dataService.getIsPEPJoint(),
        ecr: this.dataService.getIsECRJoint(),
        fatca: this.dataService.getIsFATCAJoint(),
        trabajadorPesquero: this.dataService.getIsFishermanJoint()
      }
    };
    this.store.dispatch(FinancialDataManagerCreateActions.getFinancialDataManagerCreate({ request }));
  }

  maskPepButton(val) {
    if (this.formData.controls.isPEPJoint.value === true && this.pepCont === 1 && val === false) {
      this.maskPep = true;
    } else {
      this.maskPep = false;
    }
  }
  checkPep(val?: boolean) {
    this.maskPepButton(val);
    if (this.formData.controls.isPEPJoint.value === true) {
      this.pepCont++;
      this.invalidPep = val !== true;
    } else {
      this.invalidPep = false;
      this.pepCont = 0;
    }
  }

  private checkNationality() {
    const nationality = this.dataService.getNationalityJoint();
    if (nationality === '4016') {
      this.formData.controls.isFATCAJoint.setValue(true);
      this.formData.controls.isFATCAJoint.disable();
      this.formData.controls.isECRJoint.disable();
    } else if (nationality !== '4028') {
      this.formData.controls.isECRJoint.setValue(true);
      this.formData.controls.isECRJoint.disable();
      this.formData.controls.isFATCAJoint.disable();
    }
  }
  disableFields() {
    if (this.formData.controls.isFATCAJoint.value === true) {
      this.formData.controls.isECRJoint.disable();
    }
    if (this.formData.controls.isFATCAJoint.value === false) {
      this.formData.controls.isECRJoint.enable();
    }
    if (this.formData.controls.isECRJoint.value === true) {
      this.formData.controls.isFATCAJoint.disable();
    }
    if (this.formData.controls.isECRJoint.value === false) {
      this.formData.controls.isFATCAJoint.enable();
    }
  }

  checkCigoData() {
    if (this.dataService.getJointIsClient() || this.privateMode) {
      const cigo = this.dataService.getCigoDataJoint();
      if (cigo.informacionFinancieraCliente.PEP === 1) {
        this.pepMarkByCigo = true;
        this.formData.controls.isPEPJoint.setValue(true);
        this.formData.controls.isPEPJoint.disable();
      }
      if (cigo.informacionFinancieraCliente.FATCA && cigo.informacionFinancieraCliente.FATCA.indicadorFatca === 'true') {
        this.formData.controls.isFATCAJoint.setValue(true);
        this.formData.controls.isFATCAJoint.disable();
        this.formData.controls.isECRJoint.disable();
        this.isMarkByCIGO = true;
      }
    }
  }

  sliderHandler(index) {
    index === 0 ? this.checkPep() : this.disableFields();
    this.expandIndex(index, true);
  }

  checkFisherman() {
    this.showFisherman = this.isExecutive && this.dataService.getAccountType() === 'CTS';
  }

  expandIndex(i, slider?) {
    this.expandedIndex = i === this.expandedIndex ? slider ? i : undefined : i;
  }

  getIsWC(): boolean {
    const isWc = !!this.isWC;
    return isWc;
  }
}
